import React from 'react'
import { Tag } from 'antd'

const RecommendedTag: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <Tag style={{ marginLeft: 8, ...style }} color="gold">
    Recommended
  </Tag>
)

export default RecommendedTag
